"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_js_1 = __importDefault(require("@hh.ru/analytics-js"));
/** На странице списка договоров в работодательском кабинете есть список активных договоров, где его можно скачать. Данным событием регистрируем каждое скачивание. */
const employerAgreementDownloadButtonClick = ({ agreementId, sellerId, agreementType, ...analyticsParams }) => analytics_js_1.default.sendHHEventButtonClick("employer_agreement_download", { agreementId, sellerId, agreementType, ...analyticsParams });
exports.default = employerAgreementDownloadButtonClick;
